import { useSelector } from 'react-redux'
import { useMemo } from 'react'

import {
  dv360NegativeKeywordListsSelector,
  dv360TargetingSelector
} from '../../../../../../modules/selectors/dv360Constants'
import { targetingTypes } from '../../../LineItemDv360Create/fields'

export const useGetAttachedNegativeKeywordsLists = () => {
  const targeting = useSelector(dv360TargetingSelector)
  const dv360NegativeKeywordLists = useSelector(dv360NegativeKeywordListsSelector)

  const negativeKeywordsListsTargetingOptions = useMemo(() => {
    return targeting.filter(option => option.type === targetingTypes.TARGETING_TYPE_NEGATIVE_KEYWORD_LIST)
  }, [targeting])

  const attachedNegativeKeywordsLists = useMemo(() => {
    return dv360NegativeKeywordLists.filter(negativeKeywordList =>
      negativeKeywordsListsTargetingOptions.some(option => option.negative_keyword_list_id === negativeKeywordList.id)
    )
  }, [dv360NegativeKeywordLists, negativeKeywordsListsTargetingOptions])

  return attachedNegativeKeywordsLists
}
